module.exports = __webpack_public_path__ + "static/media/02_R.2e90dbcd.png";